import alt from '../alt';
import LoginActions from './LoginActions';
import CartActions from '../Cart/CartActions'

class LoginStore {
	constructor(){

		this.state = {
			loginModel: {
				Username: '',
				Password: '',
				canSubmitLogin: false
			},
			showForgotPassword: false,
			loginHasError: false,
			accountModel: {
				FirstName: '',
				LastName: '',
				Email: '',
				Password: '',
				PasswordConfirm: '',
				canSubmitAccount: false,
			},
			accountHasError: false,
			panelShowing: "login",
			TaCText:'',
			TaCUrl:'',
			TacActive:false,
			TacCheckbox:false,
			isTacAccepted:true,
			showModal:false
		}

		this.bindListeners({
			updateAccountState: LoginActions.UPDATE_ACCOUNT_STATE,
			updateLoginState: LoginActions.UPDATE_LOGIN_STATE,
			loginSuccess: LoginActions.LOGIN_SUCCESS,
			loginFailure: LoginActions.LOGIN_FAILURE,
			isTacAccepted:LoginActions.IS_TAC_ACCEPTED_SUCCESS,
			enrollSuccess: LoginActions.ENROLL_SUCCESS,
			enrollFailure: LoginActions.ENROLL_FAILURE,
			showPanel: LoginActions.SHOW_PANEL,
			GetTacSucess:LoginActions.GET_TAC_SUCESS,
			isTacFeatureActiveSucess: LoginActions.IS_TAC_FEATURE_ACTIVE_SUCESS,
			toggleTac: LoginActions.TOGGLE_TAC,
			saveTac :LoginActions.SAVE_TAC_SUCESS
		});
	}

     saveTac(){
		 return false;
	 }
	
	isTacAccepted(data){
		this.setState({
			isTacAccepted:data
		});
	}
	toggleTac(){
		this.setState({
			TacCheckbox: !this.state.TacCheckbox
		})

	}
	isTacFeatureActiveSucess(data){
		this.setState({
			TacActive:data
			
		});
	}
	loginSuccess(data) {
		//window.location.replace('../');
		return true;
	}

	loginFailure(response){
		this.setState({
			loginHasError: true
		})
	}
    GetTacSucess(data){
		this.setState({
			TaCText:data.text,
			TaCUrl : data.url
		});
	}
	enrollSuccess(data) {
		return true;
	}

	enrollFailure(response){
		this.setState({
			accountHasError: true
		})
	}

	updateAccountState(newState){
		this.setState({
			accountModel: newState
		});
		return true;
	}

	updateLoginState(newState){
		this.setState({
			loginModel: newState
		});
		return true;
	}

	showPanel(panel){
		this.setState({
			panelShowing: panel
		});
		return true;
	}
}

export default alt.createStore(LoginStore, 'LoginStore');



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/Login/LoginStore.js